/**
 * axios 统一请求实例
 * - 集中管理后端地址（baseURL）
 * - 响应拦截器统一解包，业务代码直接拿到 Result 对象
 */
import axios from 'axios'

// 后端服务地址：可通过环境变量 VUE_APP_API_BASE 覆盖，默认本地 5070
const BASE_URL = process.env.VUE_APP_API_BASE || 'http://localhost:5070'

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 15000
})

// 响应拦截器：统一取出后端 Result 的 data 部分
request.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const msg = (error.response && error.response.data && error.response.data.msg) || '网络异常，请稍后重试'
    return Promise.reject(new Error(msg))
  }
)

export default request
